<template>
    <rkm-modal
        :loading="loading"
        :buttons="['cancel']"
        :title="`Requisições com reserva${lote ? ` (${lote})` : ''}`"
        large
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="requisicoes"
            hide-filters
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'requisicao.numero',
                    label: 'Número',
                },
                {
                    key: 'reservado',
                    label: 'Reservado',
                    class: 'text-center'
                },
            ]
        },
    },
    data: () => ({
        lote: '',
        requisicoes: [],
    }),
    methods: {
        open(item) {

            this.lote = item.lote ? `${item.lote} - ${item.validadeLote}` : ''
            this.requisicoes = item.reservasPorRequisicao

            this.$refs.Modal.show()
        }
    },
}
</script>